// Firebase options per environment
// Project: centrajob-6d384 (shared CentraJob project)
export const firebaseOptions = {
  dev: {
    apiKey: "AIzaSyBjPUHJkcrIPwx0c61rVrC8LAxtpNnawds",
    authDomain: "centrajob-employer.firebaseapp.com",
    projectId: "centrajob-employer",
    storageBucket: "centrajob-employer.firebasestorage.app",
    messagingSenderId: "16706755304",
    appId: "1:16706755304:web:c3fecd78fb3a5470ebc75d",
    measurementId: "G-F7CPYR3Y95",
  },
  qa: {
    apiKey: "AIzaSyBjPUHJkcrIPwx0c61rVrC8LAxtpNnawds",
    authDomain: "centrajob-employer.firebaseapp.com",
    projectId: "centrajob-employer",
    storageBucket: "centrajob-employer.firebasestorage.app",
    messagingSenderId: "16706755304",
    appId: "1:16706755304:web:c3fecd78fb3a5470ebc75d",
    measurementId: "G-F7CPYR3Y95",
  },
  prod: {
    apiKey: "AIzaSyBjPUHJkcrIPwx0c61rVrC8LAxtpNnawds",
    authDomain: "centrajob-employer.firebaseapp.com",
    projectId: "centrajob-employer",
    storageBucket: "centrajob-employer.firebasestorage.app",
    messagingSenderId: "16706755304",
    appId: "1:16706755304:web:a43f5870decec835ebc75d",
    measurementId: "G-Z7P17N0YYX",
  },
};
